import * as amplitude from '@amplitude/analytics-browser';

// Initialize Amplitude with your API key
amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY || 'default-key', {
    defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true,
    },
});

// Event types
export enum AnalyticsEvent {
    VIEW_PODCAST = 'view_podcast',
    VIEW_SPONSOR = 'view_sponsor',
    SEARCH_PODCASTS = 'search_podcasts',
    SEARCH_SPONSORS = 'search_sponsors',
    FILTER_PODCASTS = 'filter_podcasts',
    FILTER_SPONSORS = 'filter_sponsors',
    CLICK_DASHBOARD = 'click_dashboard',
    CLICK_PODCAST_LINK = 'click_podcast_link',
    CLICK_SPONSOR_LINK = 'click_sponsor_link',
    SORT_PODCASTS = 'sort_podcasts',
    CLICK_SPONSOR_EPISODES = 'click_sponsor_episodes',
    // Landing page events
    CLICK_HERO_CTA = 'click_hero_cta',
    CLICK_VIEW_REPORTS = 'click_view_reports',
    CLICK_EXPLORE_NOW = 'click_explore_now',
    // Ranking page events
    // Page view events
    VIEW_LANDING_PAGE = 'view_landing_page',
    VIEW_REPORTS_PAGE = 'view_reports_page',
    VIEW_RECURSOS_PAGE = 'view_recursos_page',
    VIEW_EXPLORAR_PAGE = 'view_explorar_page',
    CLICK_RESOURCE = 'click_resource',
    // Contact dialog events
    CLICK_REQUEST_ACCESS = 'click_request_access',
    CLICK_REQUEST_DEMO = 'click_request_demo',
    /** CTA in the live rankings promo popup (opens contact dialog) */
    CLICK_LIVE_RANKINGS_CONTACT = 'click_live_rankings_contact',
    /** Live rankings email gate: magic link requested (user id set to email in identify) */
    LIVE_RANKINGS_MAGIC_LINK_REQUESTED = 'live_rankings_magic_link_requested',
    /** Live rankings: session cookie present; user identified in Amplitude */
    LIVE_RANKINGS_SESSION = 'live_rankings_session',
    SUBMIT_CONTACT_FORM = 'submit_contact_form',
    // CTA events
    CLICK_CREATE_PROFILE = 'click_create_profile',
    CLICK_REQUEST_EXPLORER = 'click_request_explorer',
    CLICK_REQUEST_REPORTS = 'click_request_reports',
    VIEW_PUBLIC_EXPLORER_RANKINGS = 'view_public_explorer_rankings',
}

// Analytics service
export const analytics = {
    // Track a simple event
    track: (eventName: AnalyticsEvent, properties?: Record<string, any>) => {
        amplitude.track(eventName, properties);
    },

    // Set user properties
    identify: (userId: string, properties?: Record<string, any>) => {
        amplitude.setUserId(userId);
        if (properties) {
            const identify = new amplitude.Identify();
            Object.entries(properties).forEach(([key, value]) => {
                identify.set(key, value);
            });
            amplitude.identify(identify);
        }
    },

    // Reset the user
    reset: () => {
        amplitude.reset();
    },
};

export default analytics;
